<template>
  <div
    v-if="hasNoticeCard()"
    class="notice-card-container"
    :class="{ 'has-sidebar': !getSideBarState.hideSideBar }"
    :style="{ 'background': options.backgroundColor, 'color': options.textColor }"
  >
    <div class="text-container">
      <div class="icon-container">
        <i :class="options.iconName"/>
      </div>

      <div class="text">
        <b v-if="hasTitle()">{{ options.title }}</b>

        {{ options.text }}

        <a v-if="options.knowMore">Saiba mais</a>
      </div>
    </div>

    <div v-if="hasButton()" class="button-container">
      <button-component
        v-ripple="'rgba(255, 255, 255, 0.35)'"
        :pathView="options.button.action"
        :text="options.button.text"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Button from '@/components/Button';

  export default {
    name: 'NoticeCard',

    components: {
      'button-component': Button
    },

    props: {
      options: {
        type: Object,
        default() {
          return {
            backgroundColor: '#000',
            textColor: '#FFF',
            iconName: 'icon-dashboard',
            title: 'Title.',
            text: 'Text',
            button: {
              action: '/',
              text: 'Button'
            }
          };
        }
      }
    },

    computed: {
      ...mapGetters([
        'getSideBarState',
      ]),
    },

    methods: {
      hasButton() {
        return this.options.button != undefined;
      },

      hasTitle() {
        return this.options.title != undefined;
      },

      hasNoticeCard() {
        return !this.$service.isEmptyObject(this.options);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .notice-card-container {
    min-height: 50px;
    padding: 5px 15px;
    width: 100%;
    font-size: 16px;

    justify-content: center;
    align-items: center;
    display: flex;

    .button-container {
      height: 40px;
      width: 120px;
      display: flex;
      align-items: center;
    }

    i {
      margin-right: 0.5rem;
    }

    .text-container {
      font-size: 16px;
      display: flex;
      justify-content: center;

      .icon-container {
        margin-top: 4px;
      }

      .text {
        margin-right: 1rem;
        font-weight: 400;

        b {
          font-weight: 500;
        }
      }
    }

    a {
      text-decoration: none;
      color: #1261cc;
    }
  }

  @media (max-width: 1005px) {
    .notice-card-container {
      flex-direction: column;
      align-items: flex-start;

      .text-container {
        .text {
          margin: 0;
        }
      }

      .button-container {
        margin-left: 1.5rem;
        margin-top: 0.5rem;
      }
    }
  }

  @media (max-width: 767px) {
    .notice-card-container {
      padding: 10px 15px;

      .text-container {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 480px) {
    .notice-card-container {
      &.has-sidebar {
        display: none;
      }
    }
  }
</style>